require("bootstrap");
import AutoNumeric from "autonumeric";
import { format, validate } from "rut.js";
import { checkEmailConfirmation, validateEmail } from "../utils";
import "../selectors";
import "../payments/mercadopago";
import { lightOrDark } from "../utils";
import { formatPhoneNumber, loadPhoneNumber } from "../../../backoffice/utils";
import { update_product_currency, update_product_amount } from "./products";

var subscription_type = window.subscription_type || "once";
var currency_type = window.currency_type || "clp";
var locale = window.locale || "es";
var recaptcha_site_key = window.recaptcha_site_key;
let fintoc_bank = null;

$(document).ready(function () {
  var disabled = false;
  let currency = currency_type;
  var type = subscription_type;
  window.donation_type = type;
  var amountin;
  loadPhoneNumber();

  function pickTextColorBasedOnBgColorAdvanced(bgColor, lightColor, darkColor) {
    var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uicolors = [r / 255, g / 255, b / 255];
    var c = uicolors.map((col) => {
      if (col <= 0.03928) {
        return col / 12.92;
      }
      return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    console.log(L);
    return L > 0.55 ? darkColor : lightColor;
  }
  var platform_title = document.querySelector("#basic-platform-title");
  if (platform_title) {
    var color = platform_title.getAttribute("data-color");
    var font_color = pickTextColorBasedOnBgColorAdvanced(
      color,
      color,
      "#000000"
    );
    const note = platform_title;
    note.style.color = font_color;
    if (font_color == "#000000") {
      $(".currency-selector-button").css("color", font_color);
    }
  }
  var Fn = {
    // Valida el rut con su cadena completa "XXXXXXXX-X"
    formatRut: function (rut) {
      var pointless = rut.split(".").join("");
      var dashless = pointless.split("-").join("");
      return (
        dashless.substring(0, dashless.length - 1) +
        "-" +
        dashless.substring(dashless.length - 1, dashless.length)
      );
    },

    validaRut: function (rutCompleto) {
      //if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var tmp = Fn.formatRut(rutCompleto);
      var tmp2 = tmp.split("-");
      var digv = tmp2[1];
      var rut = tmp2[0];
      if (digv == "K") digv = "k";
      return Fn.dv(rut) == digv;
    },
    dv: function (T) {
      var M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10))
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },
  };

  $("#donator_phone_number").on("keypress", function (e) {
    if (e.which == 32) {
      return false;
    }
  });

  // Check if type-currency combo is valid
  const manageAvailableCurrencies = () => {
    const valid = {
      subscription:
        'label[data-currency="clp"],label[data-currency="usd"],label[data-currency="uf"]',
      once: 'label[data-currency="usd"], label[data-currency="clp"], label[data-currency="eur"]',
    };
    $("#currency-type").val(currency);
    $(".currency-selection label").addClass("btn-disabled");
    $(".currency-selection").find(valid[type]).removeClass("btn-disabled");
    const raffle_amounts = document.querySelector("#raffle-amounts");
    if (raffle_amounts) {
      var amount = $(raffle_amounts).attr(`data-ticket-${currency}-amount`);
      $(".raffle-ticket-price").hide();
      $(`.${currency}-ticket-price`).show();
      $("#product-quantity-desktop").attr("data-price", amount);
      $("#product-quantity-mobile").attr("data-price", amount);
      const total_amount = amount * $("#product-quantity-desktop").val();
      update_product_amount(total_amount);
    }
  };

  // Modify view to show available options
  const managePaymentOptions = () => {
    manageAvailableCurrencies();
    validateAmountToDonate();
    // Set active type
    $(".donation-type-select button").removeClass("btn-active");
    $(".donation-type-select button").removeClass("active");
    $(`.donation-type-select button[data-type="${type}"]`).addClass(
      "btn-active"
    );
    $(`.donation-type-select button[data-type="${type}"]`).addClass("active");

    // Set active currency
    $(".currency-selection label").removeClass("btn-active");
    $(".currency-selection label").removeClass("active");
    $(`.currency-selection label[data-currency="${currency}"]`).addClass(
      "btn-active"
    );
    $(`.currency-selection label[data-currency="${currency}"]`).addClass(
      "active"
    );

    // Show/hide available options
    const selector = ".payment-selection .custom-control";
    var donation_type = "";
    if (type == "charity-wreaths" || type == "cards2") {
      donation_type = "cards";
    } else if (type == "projects" || type == "wizo-subscription")
      donation_type = "once";
    else {
      donation_type = type;
    }

    $(`${selector}`).addClass("hidden-input");
    $(`${selector}.payment-${currency}.payment-${donation_type}`).removeClass(
      "hidden-input"
    );
    $(`.price-cards`).addClass("hidden-input");
    $(`.price-cards.payment-${currency}.payment-${donation_type}`).removeClass(
      "hidden-input"
    );
    $(`${selector}:not(.hidden-input) input`).first().prop("checked", true);
    $(".donator_authenticatable").prop("checked", type === "subscription");
  };

  // Set currency
  const setCurrency = (currency, type, amountin) => {
    $("#currency-type").val(currency);
    let min_amount_json_default = {
      uf: "0.02",
      clp: "1000",
      eur: "1",
      usd: "1",
    };
    let min_amount_json;
    if (!!($('#cause-product-price')[0])){
      let cause_amount = update_product_currency(currency)
      amountin[0].set(cause_amount);
    }
    if ($("#amount_form").attr("data-min-amount")) {
      min_amount_json = JSON.parse($("#amount_form").attr("data-min-amount"));
    } else {
      min_amount_json = { uf: "0.02", clp: "1000", eur: "1", usd: "1" };
    }
    if (currency == "clp") {
      if (type == "once") {
        $("#min-amount-donation-text-clp").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
        $("#donator_donation_transactions_attributes_0_amount").prop(
          "placeholder",
          `${locale == "es" ? "Mínimo de " : ""}` +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (type == "subscription") {
        $("#min-amount-donation-text-clp").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
        $("#donator_donation_transactions_attributes_0_amount").prop(
          "placeholder",
          `${locale == "es" ? "Mínimo de " : ""}` +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      }
      amountin[0].update({
        digitGroupSeparator: ".",
        decimalCharacter: ",",
        decimalPlaces: 0,
      });
    } else if (currency == "usd") {
      if (type == "once") {
        $("#min-amount-donation-text-usd").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
        $("#donator_donation_transactions_attributes_0_amount").prop(
          "placeholder",
          `${locale == "es" ? "Mínimo de " : ""}` +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (type == "subscription") {
        $("#min-amount-donation-text-usd").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
        $("#donator_donation_transactions_attributes_0_amount").prop(
          "placeholder",
          `${locale == "es" ? "Mínimo de " : ""}` +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      }
      amountin[0].update({
        digitGroupSeparator: ".",
        decimalCharacter: ",",
        decimalPlaces: 0,
      });
    } else if (currency == "uf") {
      if (type == "once") {
        $("#min-amount-donation-text-uf").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
        $("#donator_donation_transactions_attributes_0_amount").prop(
          "placeholder",
          `${locale == "es" ? "Mínimo de " : ""}` +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (type == "subscription") {
        $("#min-amount-donation-text-uf").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
        $("#donator_donation_transactions_attributes_0_amount").prop(
          "placeholder",
          `${locale == "es" ? "Mínimo de " : ""}` +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      }
      amountin[0].update({
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalPlaces: 2,
      });
    }
    managePaymentOptions();
  };

  // Donation type selector
  $(".donation-type-select button").click(({ target }) => {
    type = target.getAttribute("data-type");
    window.donation_type = type;
    var single_optional_email = $("#email_form").attr(
      "data-single-email-optional"
    );
    let min_amount_json_default = {
      uf: "0.02",
      clp: "1000",
      eur: "1",
      usd: "1",
    };
    let min_amount_json;
    if ($("#amount_form").attr("data-min-amount")) {
      min_amount_json = JSON.parse($("#amount_form").attr("data-min-amount"));
    } else {
      min_amount_json = { uf: "0.02", clp: "1000", eur: "1", usd: "1" };
    }
    managePaymentOptions();
    if (type === "subscription") {
      $('[name="recurring_radio"]#subscription')[0].checked = true
      $(".donator-login-button").removeClass("hidden-input");
      $("#amount_form.dynamic-label label").text(
        locale == "en" ? "Monthly amount" : "Monto a donar mensualmente"
      );
      $("#donator_email_label").html(
        locale == "en" ? "Mail" : "Ingresa tu email"
      );
      $("#donator_email_fundraising").prop("required", true);
      $("#donator_email_platform").prop("required", true);
      $("#donator_email_fundraising").addClass("form-control", true);
      $(".currency-selection label[data-currency='uf']").show();
      $(".currency-selection label[data-subscription='false']").hide();
      $("#recurring-checkbox").prop("checked", true);
      $(".platform").removeClass("platform-cards");
      $(".platform").removeClass("platform-cards2");
      $(".platform").removeClass("platform-once");
      $(".platform").addClass("platform-subscription");
      $(".platform").removeClass("projects");
      $(".app-container").show();
      $(".card-container").hide();
      $(".greeting-cards-banner").hide();
      $(".charity-wreaths-container").hide();
      $(".charity-wreaths-banner").hide();
      $(".donations-options").hide();
      $("#subscription-header").show();
      $(".form-title.subscription-header").show();
      $("#once-header").hide();
      $(".form-title.once-header").hide();
      $("#projects-form-container").hide();
      $("#donations-form-container").show();
      $("#recurring-checkbox-container").show();
      $("#basic-platform-title").text($("#subscription-title").text());

      $("#donator_donation_transactions_attributes_0_amount").prop(
        "placeholder",
        `${locale == "es" ? "Mínimo de " : ""}` +
          min_amount_json[currency] +
          " " +
          currency.toString().toUpperCase()
      );
      if (currency == "clp") {
        $("#min-amount-donation-text-clp").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (currency == "usd") {
        $("#min-amount-donation-text-usd").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (currency == "uf") {
        $("#min-amount-donation-text-uf").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      }
    } else if (type === "once") {
      $('#single-donation[name="recurring_radio"]')[0].checked = true
      
      $(".donator-login-button").addClass("hidden-input");
      $("#amount_form.dynamic-label label").text(
        locale == "en" ? "Amount" : "Monto a donar"
      );
      $("#donator_email_label").html(
        locale == "en"
          ? `Mail ${single_optional_email == "false" ? "" : "(Optional)"}`
          : `Email ${single_optional_email == "false" ? "" : "(Opcional)"}`
      );
      $("#donator_email_fundraising").prop("required", false);
      $("#donator_email_platform").prop(
        "required",
        single_optional_email == "false" ? true : false
      );
      $("#donator_email_fundraising").removeClass("form-control", true);
      $(".currency-selection label[data-currency='usd']").show();
      $(".currency-selection label[data-currency='uf']").hide();
      $("#recurring-checkbox").prop("checked", false);
      $(".platform").removeClass("platform-cards");
      $(".platform").removeClass("platform-cards2");
      $(".platform").removeClass("platform-subscription");
      $(".platform").addClass("platform-once");
      $(".platform").removeClass("projects");
      $(".app-container").show();
      $(".card-container").hide();
      $(".greeting-cards-banner").hide();
      $(".charity-wreaths-container").hide();
      $(".charity-wreaths-banner").hide();
      $("#subscription-header").hide();
      $(".form-title.subscription-header").hide();
      $(".donations-options").show();
      $("#once-header").show();
      $(".form-title.once-header").show();
      $("#projects-form-container").hide();
      $("#donations-form-container").show();
      $("#recurring-checkbox-container").show();
      $("#basic-platform-title").text($("#once-title").text());
      $("#donator_donation_transactions_attributes_0_amount").prop(
        "placeholder",
        `${locale == "es" ? "Mínimo de " : ""}` +
          min_amount_json_default[currency] +
          " " +
          currency.toString().toUpperCase()
      );
      if (currency == "clp") {
        $("#min-amount-donation-text-clp").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (currency == "usd") {
        $("#min-amount-donation-text-usd").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (currency == "uf") {
        currency = "clp";
        setCurrency(currency, type, amountin);
      }
    } else if (type === "cards") {
      $(".donator-login-button").addClass("hidden-input");
      $("#amount_form.dynamic-label label").text(
        locale == "en" ? "Amount" : "Monto a donar"
      );
      $(".currency-selection label[data-currency='usd']").removeClass("active");
      $(".currency-selection label[data-currency='usd']").css(
        "display",
        "flex !important"
      );
      $("#recurring-checkbox").prop("checked", false);
      $(".platform").removeClass("platform-subscription");
      $(".platform").removeClass("platform-once");
      $(".platform").removeClass("platform-cards2");
      $(".platform").addClass("platform-cards");
      $(".platform").removeClass("projects");
      $("#subscription-header").hide();
      $("#once-header").hide();
      $(".app-container").hide();
      $(".card-container").show();
      $(".cards-container").show();
      $(".greeting-cards-banner").show();
      $(".charity-wreaths-container").hide();
      $(".charity-wreaths-banner").hide();
      $(`.select-card-container`).hide();
      $("#projects-form-container").hide();
      $("#donations-form-container").show();
      $("#recurring-checkbox-container").show();
    } else if (type === "charity-wreaths") {
      $(".donator-login-button").addClass("hidden-input");
      $("#amount_form.dynamic-label label").text(
        locale == "en" ? "Amount" : "Monto a donar"
      );
      $(".currency-selection label[data-currency='usd']").removeClass("active");
      $(".currency-selection label[data-currency='usd']").css(
        "display",
        "flex !important"
      );
      $("#recurring-checkbox").prop("checked", false);
      $(".platform").removeClass("platform-subscription");
      $(".platform").removeClass("platform-once");
      $(".platform").removeClass("platform-cards");
      $(".platform").addClass("platform-cards2");
      $(".platform").removeClass("projects");
      $(".app-container").hide();
      $(".card-container").show();
      $(".cards-container").hide();
      $("#subscription-header").hide();
      $("#once-header").hide();
      $(".greeting-cards-banner").hide();
      $(".charity-wreaths-container").show();
      $(".charity-wreaths-banner").show();
      $(".select-card-container").hide();
      $("#projects-form-container").hide();
      $("#donations-form-container").show();
      $("#recurring-checkbox-container").show();
    } else if (type === "projects") {
      $(".donator-login-button").addClass("hidden-input");
      $("#amount_form.dynamic-label label").text(
        locale == "en" ? "Amount" : "Monto a donar"
      );
      $(".currency-selection label[data-currency='usd']").removeClass("active");
      $(".currency-selection label[data-currency='usd']").css(
        "display",
        "flex !important"
      );
      $(".platform").removeClass("platform-subscription");
      $(".platform").removeClass("platform-once");
      $(".platform").removeClass("platform-cards");
      $(".platform").removeClass("platform-cards2");
      $(".platform").addClass("projects");
      $(".card-container").hide();
      $(".cards-container").hide();
      $(".greeting-cards-banner").hide();
      $(".charity-wreaths-container").hide();
      $(".charity-wreaths-banner").hide();
      $(".select-card-container").hide();
      $("#projects-form-container").show();
      $("#donations-form-container").hide();
      $("#recurring-checkbox-container").hide();
    }
  });

  // Currency selector
  $(".currency-selection label").click(({ target }) => {
    currency = target.getAttribute("data-currency");
    setCurrency(currency, type, amountin);
  });

  // Method selector
  $(".payment-selection .payment-button").click(({ currentTarget }) => {
    const kind = currentTarget.getAttribute("data-kind");
    fintoc_bank = currentTarget.getAttribute("data-bank");
    let fintoc_status = currentTarget.getAttribute("data-status");
    currency = currentTarget.hasAttribute("data-currency")
      ? currentTarget.getAttribute("data-currency")
      : currency;
    $("#currency-type").val(currency);
    if (!kind) return;
    if (kind != "fintoc_payment" || fintoc_bank) {
      $(`input:radio[value="${kind}"]`).prop("checked", true);
    }
    $("input:hidden.transaction_kind").val(kind);
    if (
      kind == "fintoc_payment" &&
      !fintoc_bank &&
      fintoc_status == "inactive"
    ) {
      currentTarget.style.border = "solid 2px";
      $(".fintoc-payment-button").removeClass("hidden-input");
      currentTarget.setAttribute("data-status", "active");
    } else if (
      kind == "fintoc_payment" &&
      !fintoc_bank &&
      fintoc_status == "active"
    ) {
      currentTarget.style.border = "none";
      $(".fintoc-payment-button").addClass("hidden-input");
      currentTarget.setAttribute("data-status", "inactive");
    } else {
      $("#new_donator").submit();
    }
  });

  // Rrecurring radio
  $('[name="recurring_radio"]').change(function () {
    if (this.value == "subscription") {
      $("#recurring-checkbox").prop("checked", true);
    } else if (this.value == "single-donation") {
      $("#recurring-checkbox").prop("checked", false);
    }
    $("#recurring-checkbox").trigger("change");
  });

  //checkbox
  $("#recurring-checkbox").change(function () {
    var single_optional_email = $("#email_form").attr(
      "data-single-email-optional"
    );
    let min_amount_json_default = {
      uf: "0.02",
      clp: "1000",
      eur: "1",
      usd: "1",
    };
    let min_amount_json;
    if ($("#amount_form").attr("data-min-amount")) {
      min_amount_json = JSON.parse($("#amount_form").attr("data-min-amount"));
    } else {
      min_amount_json = { uf: "0.02", clp: "1000", eur: "1", usd: "1" };
    }
    if (this.checked) {
      type = "subscription";
      $(".donator-login-button").removeClass("hidden-input");
      $("#amount_form.dynamic-label label").text(
        locale == "en" ? "Monthly amount" : "Monto a donar mensualmente"
      );
      $(".currency-selection label[data-currency='uf']").css("display", "flex");
      $(".currency-selection label[data-subscription='false']").hide();
      $("#recurring-checkbox").prop("checked", true);
      $(".platform").removeClass("platform-once");
      $(".platform").removeClass("platform-cards");
      $(".platform").removeClass("platform-cards2");
      $(".platform").addClass("platform-subscription");
      $("#donator_email_fundraising").prop("required", true);
      $("#donator_email_platform").prop("required", true);
      $("#donator_email_fundraising").addClass("form-control", true);
      $("#donator_email_label").html(locale == "en" ? "Mail" : "Email");
      $("#subscription-header").show();
      $("#once-header").hide();
      $(".donations-options").hide();
      $("#donator_donation_transactions_attributes_0_amount").prop(
        "placeholder",
        `${locale == "es" ? "Mínimo de " : ""}` +
          min_amount_json[currency] +
          " " +
          currency.toString().toUpperCase()
      );
      if (currency == "clp") {
        $("#min-amount-donation-text-clp").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (currency == "usd") {
        $("#min-amount-donation-text-usd").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (currency == "uf") {
        $("#min-amount-donation-text-uf").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      }
      managePaymentOptions();
    } else {
      type = "once";
      $(".donator-login-button").addClass("hidden-input");
      $("#amount_form.dynamic-label label").text(
        locale == "en" ? "Amount" : "Monto a donar"
      );
      $(".currency-selection label[data-currency='usd']").removeClass("active");
      $(".currency-selection label[data-currency='usd']").css(
        "display",
        "flex"
      );
      $(".currency-selection label[data-currency='uf']").css("display", "none");
      $("#donator_email_label").html(
        locale == "en"
          ? `Mail ${
              single_optional_email == "false"
                ? ""
                : "<span id='optional'>(Optional)</span>"
            }`
          : `Email ${
              single_optional_email == "false"
                ? ""
                : "<span id='optional'>(Opcional)</span>"
            }`
      );
      $("#donator_email_platform").prop(
        "required",
        single_optional_email == "false" ? true : false
      );
      $("#recurring-checkbox").prop("checked", false);
      $(".platform").removeClass("platform-subscription");
      $(".platform").removeClass("platform-cards");
      $(".platform").removeClass("platform-cards2");
      $(".platform").addClass("platform-once");
      $("#donator_email_fundraising").prop("required", false);
      $("#donator_email_fundraising").removeClass("form-control", true);
      $("#subscription-header").hide();
      $("#once-header").show();
      $(".donations-options").show();
      $("#donator_donation_transactions_attributes_0_amount").prop(
        "placeholder",
        `${locale == "es" ? "Mínimo de " : ""}` +
          min_amount_json_default[currency] +
          " " +
          currency.toString().toUpperCase()
      );
      if (currency == "clp") {
        $("#min-amount-donation-text-clp").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (currency == "usd") {
        $("#min-amount-donation-text-usd").text(
          "Por favor, ingresa un monto mínimo de " +
            min_amount_json_default[currency] +
            " " +
            currency.toString().toUpperCase()
        );
      } else if (currency == "uf") {
        currency = "clp";
        setCurrency(currency, type, amountin);
      }
      managePaymentOptions();
    }
  });

  // Options selector
  $(".block-option").click(({ target }) => {
    const target_type = target.getAttribute("data-type")
    if (target_type == "options") {
      const amount = target.getAttribute("data-amount");
      const block_id = target.getAttribute("data-block-id");
      const amountInput = document.getElementById(
        "donator_donation_transactions_attributes_0_amount"
      );
      amountInput.value = amount;
      $(`div.block-option`).removeClass("active-option");
      $(`div.block-option[data-block-id="${block_id}"]`).toggleClass(
        "active-option"
      );
      validateAmountToDonate(this);
    }
  });

  $("#donator_donation_transactions_attributes_0_amount").on("input", (e) => {
    validateAmountToDonate(this);
    $(`div.block-option`).removeClass("active-option");
  });

  const validateAmountToDonate = () => {
    const amount_donator = $(
      "#donator_donation_transactions_attributes_0_amount"
    );

    const current_amount =
      currency === "uf"
        ? amount_donator.val()
        : parseInt(amount_donator.val().replace(/\./g, ""));
    let min_amount;
    let min_amount_json;

    if (type == "subscription" && $("#amount_form").attr("data-min-amount")) {
      min_amount_json = JSON.parse($("#amount_form").attr("data-min-amount"));
      min_amount = {
        clp: min_amount_json["clp"],
        usd: min_amount_json["usd"],
        uf: min_amount_json["uf"],
        eur: min_amount_json["eur"],
      }[currency];
    } else {
      min_amount = {
        clp: 1000,
        usd: 1,
        uf: 0.02,
        eur: 1,
      }[currency];
    }

    if (current_amount >= min_amount) {
      $("#donator_donation_transactions_attributes_0_amount").removeClass(
        "is-invalid"
      );
      $("#new_donator").addClass("was-validated");
      $(`#amount_form div.invalid-feedback.payment-${currency}`).hide();
      return { valid: true, amount: current_amount };
    } else {
      $("#donator_donation_transactions_attributes_0_amount").addClass(
        "is-invalid"
      );
      $("#new_donator").removeClass("was-validated");
      $(`#amount_form div.invalid-feedback`).hide();
      $(`#amount_form div.invalid-feedback.payment-${currency}`).show();
      return { valid: false, amount: current_amount };
    }
  };

  const validateFormData = (form_hash) => {
    let reversed_array = Object.keys(form_hash);
    reversed_array.reverse();
    reversed_array.shift();
    reversed_array.forEach(function (element) {
      const field = form_hash[element];
      if (field.checkValidity() === false) {
        field.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  };

  amountin = new AutoNumeric.multiple(
    "#donator_donation_transactions_attributes_0_amount",
    {
      digitGroupSeparator: ".",
      decimalCharacter: ",",
      decimalPlaces: 0,
    }
  );
  // End autonumeric format amount input

  function copy(copyId) {
    navigator.clipboard.writeText($("" + copyId).text()).then(() => {
      $(".alert").fadeIn(500, function () {
        $(".alert").fadeOut();
      });
    });
  }

  //copy-buttons
  $(".copy-button").click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    const copy_id =
      "#" + $(this).attr("id").replace("-copy-button", "") + "-field";
    copy(copy_id);
  });

  $(".copy-button-social-media").click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    navigator.clipboard.writeText(location.hostname);
    alert(
      "Se ha copiado el link de la colecta\n!Ve a compartirlo con tus contactos!"
    );
  });

  $("#donator_tax_id").on("input", ({ target }) => {
    let val = format(target.value);
    target.value = val;
  });

  $(".tax_id_input").on("input", ({ target }) => {
    let val = format(target.value);
    target.value = val;
  });

  $(".iti__country-list li").click(function () {
    this?.parentElement?.parentElement?.nextSibling?.setAttribute(
      "data-code",
      $(this).data("dial-code")
    );
    formatPhoneNumber();
  });

  $("#phone_number_hidden_input").change(function (e) {
    formatPhoneNumber();
  });

  $("#donator_tax_id").on("blur", ({ target }) => {
    const rutField = $("#donator_tax_id")[0];
    const rutValidity = rutField ? Fn.validaRut(rutField.value) : true;
    if (rutValidity === false) {
      $("#donator_tax_id").addClass("is-invalid");
      $("#donator_tax_id").removeClass("is-valid");
      $("#new_donator").removeClass("was-validated");
    } else {
      $("#donator_tax_id").addClass("is-valid");
      $("#donator_tax_id").removeClass("is-invalid");
      $("#new_donator").addClass("was-validated");
    }
  });

  $(".tax_id_input").on("blur", ({ target }) => {
    const rutField = $(".tax_id_input")[0];
    const rutValidity = rutField ? Fn.validaRut(rutField.value) : true;
    if (rutValidity === false) {
      $(".tax_id_input").addClass("is-invalid");
      $(".tax_id_input").removeClass("is-valid");
      $("#new_donator").removeClass("was-validated");
    } else {
      $(".tax_id_input").addClass("is-valid");
      $(".tax_id_input").removeClass("is-invalid");
      $("#new_donator").addClass("was-validated");
    }
  });
  // Handle form submit
  $("#new_donator").on("submit", (event) => {
    event.preventDefault();
    event.stopPropagation();
    // dentro del listener del submit
    if (disabled) return;
    disabled = true;
    setTimeout(() => {
      disabled = false;
    }, 1500);
    const form = $("#new_donator");
    form[0].classList.add("was-validated");
    const url = form.attr("action");
    const rutField = $("#donator_tax_id")[0];
    const rutValidity = rutField ? Fn.validaRut(rutField.value) : true;
    formatPhoneNumber();

    if (rutValidity === false) {
      $("#donator_tax_id").addClass("is-invalid");
      $("#donator_tax_id").removeClass("is-valid");
      $("#new_donator").removeClass("was-validated");
    } else {
      $("#donator_tax_id").addClass("is-valid");
      $("#donator_tax_id").removeClass("is-invalid");
      $("#new_donator").addClass("was-validated");
    }

    // parse amount value, to correct format
    const amountInput = document.getElementById(
      "donator_donation_transactions_attributes_0_amount"
    );
    const amount_validate = validateAmountToDonate(amountInput);
    amountInput.value = amount_validate.amount || "";

    var validMail = $("#donator_email")[0]
      ? $("#donator_email")[0].checkValidity()
      : false;
    if (!validMail && $("#donator_email")[0] === undefined) validMail = true;

    // Validates that one project is selected
    const projectForm = $("#project_form")[0];
    const isProjectSelected =
      $("input[type=radio]:checked").length != 0 ? true : false;
    isProjectSelected
      ? $("#project_form .invalid-feedback").hide()
      : $("#project_form .invalid-feedback").show();

    const payment_radio_btns =
      $(".payment-button input[type=radio]").length != 0;
    const is_payment_radio_btns_checked =
      $(".payment-button input[type=radio]:checked").length != 0;
    if (payment_radio_btns && !is_payment_radio_btns_checked) {
      alert("Selecciona un método de pago");
      return;
    }

    const projectValidate = projectForm ? isProjectSelected : true;
    grecaptcha.enterprise.ready(function () {
      grecaptcha.enterprise
        .execute(recaptcha_site_key, { action: "submit" })
        .then(function (token) {
          let captcha = $(`input[name="recaptcha_token"`);
          for (var i = 0; i < captcha.length; i++) {
            captcha[i].value = token;
          }
          if (
            form[0].checkValidity() === true &&
            amount_validate.valid === true &&
            rutValidity === true &&
            validMail === true &&
            projectValidate === true &&
            checkEmailConfirmation() === true
          ) {
            if ($(".transaction_kind").val() != "manual_transfer")
              $("#loader").show();
            else $("#transfer-modal").modal("show");
            $.ajax({
              type: "POST",
              url: url,
              data: form.serialize(), // serializes the form's elements.
            })
              .done(function (response) {
                if (response["payment_stream"] == "webpay") {
                  const url = response["url"];
                  const token = response["token"];
                  const form = $(
                    '<form action="' +
                      url +
                      '" method="post">' +
                      '<input type="hidden" name="' +
                      response["name"] +
                      '" value="' +
                      token +
                      '" />' +
                      "</form>"
                  );
                  $("body").append(form);
                  form.submit();
                } else if (response["payment_stream"] == "khipu") {
                  window.location.href = response["url"];
                } else if (response["payment_stream"] == "flow_servipag") {
                  window.location.href = response["url"];
                } else if (
                  response["payment_stream"] == "payroll_discount_payment"
                ) {
                  $("#loader").hide();
                  $("#payroll_transaction_uuid").val(
                    response["transaction_id"]
                  );
                  $("#payroll_donator_email").val(response["email"]);
                  $("#payroll-discount-modal").modal("show");
                } else if (
                  response["payment_stream"] == "payroll_discount_subscription"
                ) {
                  $("#loader").hide();
                  $("#payroll_transaction_uuid").val(
                    response["transaction_id"]
                  );
                  $("#payroll_donator_email").val(response["email"]);
                  $("#payroll-discount-modal").modal("show");
                } else if (response["payment_stream"] == "paypal") {
                  const form = $(response["form"]);
                  $("body").append(form);
                  form.submit();
                } else if (response["payment_stream"] == "paypal_payment") {
                  $("#loader").hide();
                  $("#paypal-payment-modal").modal("show");
                  paypal
                    .Buttons({
                      env: response["env"],
                      createOrder: function () {
                        return response["token"];
                      },
                      onApprove: function (data) {
                        $("#paypal-payment-modal").modal("hide");
                        $("#loader").show();
                        return $.post("/paypal/capture_order", {
                          paymentToken: data.orderID,
                        }).then(function (executeData) {
                          window.location.replace(
                            response["completed_url"] +
                              "/?dt_uuid=" +
                              response["dt_uuid"]
                          );
                        });
                      },
                      onCancel: function (data) {
                        $("#paypal-payment-modal").modal("hide");
                        $("#loader").show();
                        window.location.replace(
                          response["cancel_url"] +
                            "/?dt_uuid=" +
                            response["dt_uuid"]
                        );
                      },
                    })
                    .render("#submit-paypal-payment");
                } else if (
                  response["payment_stream"] == "paypal_subscription"
                ) {
                  $("#loader").hide();
                  $("#paypal-payment-modal").modal("show");
                  paypal
                    .Buttons({
                      env: response["env"],
                      createOrder: function () {
                        return response["token"];
                      },
                      onApprove: function (data) {
                        $("#paypal-modal").modal("hide");
                        $("#loader").show();
                        return $.post("/paypal/execute_subscription", {
                          subscriptionToken: data.orderID,
                        }).then(function (executeData) {
                          window.location.replace(response["completed_url"]);
                        });
                      },
                      onCancel: function (data) {
                        $("#paypal-modal").modal("hide");
                        $("#loader").show();
                        window.location.replace(
                          response["cancel_url"] +
                            "/?dt_uuid=" +
                            response["dt_uuid"]
                        );
                      },
                    })
                    .render("#submit-paypal-payment");
                } else if (response["payment_stream"] == "bancoestado") {
                  const form = $(
                    `<form name="0.1_fm" action="https://www.bancoestado.cl/bancoestado/aportevoluntario/aporte.asp" 
                        method="post">
                      <input type="text" name="monto" value="` +
                      response["amount"] +
                      `" style="display: none;">
                      <input type="hidden" name="id_institucion" value="` +
                      response["bancoestado_code"] +
                      `">
                    </form>`
                  );
                  $("body").append(form);
                  form.submit();
                } else if (response["payment_stream"] == "mach") {
                  window.location.href = response["url"];
                } else if (response["payment_stream"] == "manual_transfer") {
                  console.log("Nueva transacción manual.");
                } else if (response["refresh"] === true) {
                  window.scrollTo(0, 0);
                  window.location.reload();
                } else if (response["payment_stream"] == "fintoc_payment") {
                  const widget = Fintoc.create({
                    widgetToken: response["widget_token"],
                    publicKey: response["public_key"],
                    holderType: "individual",
                    product: "payments",
                    institutionId: fintoc_bank,
                    webhookUrl: response["webhook_url"],
                    onSuccess: () => {
                      window.location.href = response["success_url"];
                    },
                    onExit: () => {
                      alert(
                        "Transacción no realizada, por favor intenta nuevamente"
                      );
                      $("#loader").hide();
                    },
                  });
                  widget.open();
                } else if (
                  response["payment_stream"] == "fintoc_subscription"
                ) {
                  const widget = Fintoc.create({
                    widgetToken: response["widget_token"],
                    publicKey: response["public_key"],
                    holderType: "individual",
                    product: "subscriptions",
                    webhookUrl: response["webhook_url"],
                    onSuccess: () => {
                      console.log("success !");
                      window.location.href = response["success_url"];
                    },
                    onExit: () => {
                      alert("Ocurrió un error, por favor intenta nuevamente");
                      $("#loader").hide();
                    },
                  });
                  widget.open();
                } else if (response["payment_stream"] == "getnet_transaction") {
                  window.location.href = response["url"];
                } else if (
                  response["payment_stream"] == "mercadopago_payment"
                ) {
                  $("#loader").hide();
                  window.mercadopago_url = response["url"];
                  $("#mercadopago-payment-modal").modal("show");
                  if ($("#mercadopago-payment")) {
                    $("#mercadopago-payment").show();
                  }
                  document.getElementById(
                    "form-checkout__cardholderEmail"
                  ).value = response["donator_email"] || "";
                  document
                    .getElementById("form-checkout__submit")
                    .classList.add("btn", "btn-primary");
                  document.getElementById("form-checkout__installments").style[
                    "display"
                  ] = "none";
                } else if (response["payment_stream"] == "invalid_email") {
                  alert("Mail inválido, por favor inténtelo de nuevo.");
                  $("#loader").hide();
                } else if (
                  response["payment_stream"] == "existing_subscription"
                ) {
                  alert("Este mail ya está registrado con una suscripción.");
                  $("#loader").hide();
                } else if (
                  response["payment_stream"] == "existing_inscription"
                ) {
                  alert("Este mail ya está registrado con una inscriptión.");
                  $("#loader").hide();
                } else {
                  $("#loader").hide();
                  alert(
                    "Ha ocurrido un problema, te pedimos por favor reintentar la transacción"
                  );
                }
              })
              .fail(function (response) {
                $("#loader").hide();
                alert(
                  "Ha ocurrido un problema, te pedimos por favor reintentar la transacción"
                );
                // return location.reload();
              });
            return false;
          } else {
            console.log("Validation not going through");
            console.log(
              "Form checkValidity: " +
                (form[0].checkValidity() === true).toString()
            );
            console.log(
              "TaxID not required: " + !$("#donator_tax_id").required
            );
            if (form[0].checkValidity() === false) {
              validateFormData(form[0]);
            }
          }
        });
    });
  });
});

if ($("#finalized").html() == "true" || $("#error").html() == "true") {
  if (locale == "en") {
    $("#thanks-msg").html("Thanks for your contribution!");
    $("#thanks-text").html(
      'We appreciate your contribution, which allows us together to fulfill the dream of "Empowering women as recreators of the world and thereby contribute to a more inclusive and equalitarian society"'
    );
    $("#thanks-social").html("Follow us on our social networks!");
    $("#error-msg").html("We are sorry! Please try again.");
    $("#error-text").html(
      "An error occurred in the transaction, so your donation could not be processed"
    );
    $("#error-button").html("Retry");
  }
}

const footer_color = $(".donando-footer").attr("data-footer-color");
if (footer_color) {
  const color_type = lightOrDark(footer_color);
  const footer_image = document.getElementById("donando-footer-image");
  const social_media_icons = $(".social-media-footer-icon");
  if (color_type == "light") {
    footer_image.src =
      "https://storage.googleapis.com/fundingplatform-files/assets/donando/desarrollado-donando.png";
    social_media_icons.each((element, data) => {
      data.style.color = "#000000";
    });
  } else if (color_type == "dark") {
    footer_image.src =
      "https://storage.googleapis.com/fundingplatform-files/assets/donando/desarrollado-donando-negative.png";
    social_media_icons.each((element, data) => {
      data.style.color = "#ffffff";
    });
  }
}

(function () {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      var forms = document.getElementsByClassName("basic-needs-validation");
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            formatPhoneNumber();
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
})();
